import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { searchSelectors } from '@lifesize/nucleus';
import actions from 'actions/AddParticipantDrawer';
import { ADD_PARTICIPANT_FORM } from 'constants/AddParticipantDrawer';
import { checkForCustomEntry } from 'utils/call-utils';
import StartCallSearch from 'components/AddParticipantDrawer/Search/AddParticipantSearch';
import _get from 'lodash/get';

const searchResults = [];

const mapDispatchToProps = dispatch => ({
  handleSelectContact: (contact) => {
    dispatch(actions.selectContactForCall(contact));
    dispatch(reset(ADD_PARTICIPANT_FORM));
    dispatch(actions.setFormFocus(false));
  },
  clearSelectedCall: () => {
    dispatch(reset(ADD_PARTICIPANT_FORM));
    dispatch(actions.selectContactForCall(false));
    dispatch(actions.setFormFocus(true));
  },
  handleSetIsFocused: (isFocused) => {
    dispatch(actions.setFormFocus(isFocused));
  },
  handleEnter: (selectedContact) => {
    if (!selectedContact) return;
    dispatch(actions.selectContactForCall(selectedContact));
    dispatch(reset(ADD_PARTICIPANT_FORM));
    dispatch(actions.setFormFocus(false));
  }
});

function mapStateToProps(state) {
  const searchString = _get(state, 'app.form.participantSearch.values.addParticipantSearchBar') || '';
  const isFocused = _get(state, 'app.addParticipantDrawer.isFocused');
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  const searchContacts =
    searchSelectors.searchUsersAndRoomSystemsOutsideCall(state);
  let selectedContact = _get(searchContacts[selectionIndex], 'contact');
  if (selectionIndex > -1 &&
    searchContacts.length === 0 &&
    searchString) {
    selectedContact = {
      name: searchString,
      id: searchString,
      dialString: searchString,
      isManual: true
    };
  }

  const isSearching = _get(state, 'nucleus.directory.isSearching');
  const showCustomDial = checkForCustomEntry(searchString);
  let searchLength;
  if (searchContacts.length === 0 && searchString) {
    searchLength = 1;
  } else if (!searchString) {
    searchLength = 0;
  } else {
    searchLength = searchContacts.length;
  }

  if (searchResults.length !== searchLength) {
    searchResults.length = searchLength;
  }

  return {
    searchContacts,
    searchString,
    isFocused,
    selectedContact,
    searchResults,
    showCustomDial,
    isSearching
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(StartCallSearch);
